import React from "react"
import { useRouteMatch, Switch, Route } from "react-router-dom"
import ConsoleLayout from "../ConsoleLayout"
import AdminReportDashboard from "../features/reports/admin_reports/AdminReportDashboard"
import AdminReportPage from "../features/reports/admin_reports/AdminReportPage"
import AdminReportNav from "../features/reports/admin_reports/AdminReportNav"

export default function AdminReportRoutes() {
    const { path } = useRouteMatch()
    return (
        <Switch>
            <Route exact path={path}>
                <ConsoleLayout
                    highlightTab="admin_reports"
                    header={<AdminReportNav activeTab="dashboard" />}
                    body={<AdminReportPage view="dashboard" recordSelected={false} />}
                    sidebarType="admin_reports"
                    bodyFullWidth />
            </Route>
            {/* <Route exact path={`${path}/generated-reports`}>
                <ConsoleLayout
                    highlightTab="reports"
                    header={<ReportNav activeTab="generated-reports" />}
                    body={<ReportPage view="generated-reports" recordSelected={false} />}
                    sidebarType="reports" />
            </Route>
            <Route path={`${path}/:reportId/new`}>
                <ConsoleLayout
                    highlightTab="reports"
                    header={<ReportNav activeTab="dashboard" />}
                    body={<ReportPage view="form" recordSelected={false} />}
                    sidebarType="reports" />
            </Route>
            <Route path={`${path}/:reportId/generated-reports/:generatedReportId/edit`}>
                <ConsoleLayout
                    highlightTab="reports"
                    header={<ReportNav activeTab="generated-dashboard" />}
                    body={<ReportPage view="form" recordSelected={true} />}
                    sidebarType="reports" />
            </Route> */}
        </Switch>
    )
}
